export const generateVuexStateComputed = fieldName => ({
  get() {
    return this.model[fieldName]
  },
  set(val) {
    this.$store.commit('teamRegistration/set', { key: fieldName, val })
  },
})
